var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1594_35474",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.836182,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1594_35474)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1594_35474",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.750122,
    y: 0.836182,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1594_35474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75012 18.8362C9.20012 18.8362 8.72929 18.6403 8.33762 18.2487C7.94596 17.857 7.75012 17.3862 7.75012 16.8362V4.83618C7.75012 4.28618 7.94596 3.81535 8.33762 3.42368C8.72929 3.03201 9.20012 2.83618 9.75012 2.83618H18.7501C19.3001 2.83618 19.771 3.03201 20.1626 3.42368C20.5543 3.81535 20.7501 4.28618 20.7501 4.83618V16.8362C20.7501 17.3862 20.5543 17.857 20.1626 18.2487C19.771 18.6403 19.3001 18.8362 18.7501 18.8362H9.75012ZM9.75012 16.8362H18.7501V4.83618H9.75012V16.8362ZM5.75012 22.8362C5.20012 22.8362 4.72929 22.6403 4.33762 22.2487C3.94596 21.857 3.75012 21.3862 3.75012 20.8362V6.83618H5.75012V20.8362H16.7501V22.8362H5.75012Z",
    fill: "#224CD8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.305081f50073c6a4c63e23eeb8f46da6.svg";
export { ForwardRef as ReactComponent };